var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2984_60187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.22222 3.5H6.141C6.26712 3.50009 6.39103 3.53448 6.50038 3.59975C6.60973 3.66501 6.70071 3.75888 6.76428 3.872L7.53272 5.23925C7.68037 5.50218 7.87785 5.73126 8.11322 5.91265C8.34859 6.09403 8.61695 6.22393 8.90206 6.2945L12.2799 7.13C12.912 7.2862 13.4749 7.6591 13.8777 8.18847C14.2806 8.71785 14.4998 9.37279 14.5 10.0475V11.75C14.5 11.9489 14.4239 12.1397 14.2885 12.2803C14.153 12.421 13.9693 12.5 13.7778 12.5H2.22222C2.03068 12.5 1.84698 12.421 1.71153 12.2803C1.57609 12.1397 1.5 11.9489 1.5 11.75V4.25C1.5 4.05109 1.57609 3.86032 1.71153 3.71967C1.84698 3.57902 2.03068 3.5 2.22222 3.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.5L10.5 7.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.5V11.7C5.5 10.8513 5.16286 10.0374 4.56274 9.43726C3.96263 8.83714 3.14869 8.5 2.3 8.5H1.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.5L7.5 5.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2984_60187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoes);
export default __webpack_public_path__ + "static/media/Shoes.d13168c648e17d1e3de0eb17dd169484.svg";
export { ForwardRef as ReactComponent };